import React from 'react';

const FirstIcon = ({ className = '' }) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`inline-block ${className}`}
  >
    <path
      d="M12.4541 13.4167L7.87077 7.00004L12.4541 0.583374H10.2083L5.62493 7.00004L10.2083 13.4167H12.4541ZM6.99993 13.4167L2.4166 7.00004L6.99993 0.583374H4.7541L0.170768 7.00004L4.7541 13.4167H6.99993Z"
      fill="currentColor"
    />
  </svg>
);

export default FirstIcon;
